const template = {
    salon: {
        name: null,
        address: null,
        postalcode: null,
        city: null,
        telephone: null,
        website: null,
        photos: [],
    },

    urls: {},

    settings: {        
        theme: {
			colors: {
				accent: '#ff0000'
			}
		},

        widget: {
            enabled: true,
            chat: {
                enabled: false
            },
            analytics: {
                enabled: false,
                type: 'none',
                account: ''
            },
            ads: {
                enabled: false,
                type: 'none',
                account: '',
                label: ''
            }
        },

        integrations: {
            reserve: false
        },

        customer: {
            step: 'late',
            allow: 'all',
            validate: {
                type: 'none',
                method: 'email'
            }
        },

        cancel: {
            warning: false,
        },

        terms: {
            conditions: '',
            privacy: ''
        },

        emergency: {
            enabled: false,
            blocked: false,
            title: '',
            contents: ''
        },

        waitlist: {
            enabled: true
        },

        showPrice: true,
        stepsOrder: 'treatment,employee',
        terminology: 'salon',
        formality: 'formal',
        treatmentGroups: []
    },

    state: {
        direction: 'none'
    }
};

const data = $state(template);

export default data;